import { SASSMALL_BOOTSTRAP_SITE_URL } from "../constants";
import { getSassmallTenantDomain } from "../storage";
import { getCurrentDevSiteConfig } from "~/utils/globalData";
import { sassmallRequest } from "./client";

function isLocalHost(hostname: string) {
  return hostname === "localhost"
    || hostname === "127.0.0.1"
    || hostname.endsWith(".localhost")
    || hostname.startsWith("192.168.")
    || hostname.startsWith("10.");
}

function resolveBootstrapUrl(explicitUrl?: string) {
  const normalizedUrl = String(explicitUrl || "").trim();
  if (normalizedUrl) {
    try {
      const parsed = new URL(/^[a-z]+:\/\//i.test(normalizedUrl) ? normalizedUrl : `http://${normalizedUrl}`);
      if (!isLocalHost(parsed.hostname)) return parsed.origin;
    }
    catch {
      // Fall through to the configured Sassmall development site.
    }
  }
  if (process.client && !isLocalHost(window.location.hostname)) return window.location.origin;
  return getCurrentDevSiteConfig().sassmallBootstrapUrl || SASSMALL_BOOTSTRAP_SITE_URL;
}

function normalizeDealerShopPayload(payload: any) {
  const shopInfo = payload?.data;
  const nextOtherJson = shopInfo?.otherJson;
  if (!shopInfo || !nextOtherJson || typeof nextOtherJson !== "object") return payload;
  const followData = shopInfo.offiaccountFollowData || {};
  const normalizedPayload = {
    ...payload,
    data: {
      ...shopInfo,
      offiaccountFollowData: {
        ...followData,
        otherJson: {
          ...(followData.otherJson || {}),
          ...nextOtherJson,
        },
      },
    },
  };
  const tenantDomain = payload?.__tenantDomain || payload?.["x-tenant-domain"];
  if (tenantDomain) {
    Object.defineProperty(normalizedPayload, "__tenantDomain", {
      configurable: true,
      enumerable: false,
      value: tenantDomain,
    });
  }
  return normalizedPayload;
}

export async function querySassmallDealerShop(data: Record<string, any> = {}) {
  const requestData = data.param || data;
  const response = await sassmallRequest("/site/bootstrap", {
    method: "GET",
    query: { url: resolveBootstrapUrl(requestData.url || requestData.shopBackUrl) },
    skipAuth: true,
    skipTenant: true,
  });
  return normalizeDealerShopPayload(response);
}

export function getSassmallActivePage(data: Record<string, any> = {}, tenantDomain?: string) {
  return sassmallRequest("/admin/manage/activityPage/activePageList", {
    method: "POST",
    body: data.param || data,
    skipAuth: true,
    tenantDomain: tenantDomain || getSassmallTenantDomain(),
  });
}
